import first from "./first";
import second from "./second";
import third from "./third";
import fourth from "./fourth";
import fifth from "./fifth";

export default {
    name: 'customAplications',
    components: {
        first,
        second,
        third,
        fourth,
        fifth
    },
    data() {
        return {

        }
    },
    mounted() {},
    method: {

    }
}